<script lang="ts">
	import { t } from '../../i18n/i18n'
	import { contactData } from '../stores'
	import Tooltip from './Tooltip.svelte'
	import { afterUpdate, getContext } from 'svelte'
	import type { Writable } from 'svelte/store'

	const isSaasInternalLot: Writable<boolean | undefined> = getContext('isSaasInternalLot') ?? false

	let showTooltip: boolean = false
	let contactMailContainer: HTMLElement
	const isValidPhoneNumber = (str: string) =>
		/(\(?([\d \-\)\–\+\/\(]+){6,}\)?([ .\-–\/]?)([\d]+))/.test(str) //see https://stackoverflow.com/questions/41538589/regexp-for-german-phone-number-format/53854183#53854183

	afterUpdate(() => {
		contactMailContainer = document.querySelectorAll('.contact-mail')[0] as HTMLElement
		if (contactMailContainer && isEllipsisActive(contactMailContainer)) {
			showTooltip = true
		}
	})

	function isEllipsisActive(element: HTMLElement) {
		return element.offsetWidth < element.scrollWidth
	}

	$: contactMobileLength = $contactData?.mobile?.length ?? 0
	$: contactPhoneLength = $contactData?.phone?.length ?? 0
	$: contactMailLength = $contactData?.eMail?.length ?? 0
	$: contactNameLength = $contactData?.fullName?.length ?? 0
</script>

{#if contactNameLength > 0}
	<div class="contact-box-optimizer">
		<div class="contact-box-contact">
			<span class="contact-box-headline">
				{$isSaasInternalLot ? $t('UI.Saas.projectContact') : $t('UI.MineralMinds.contactPerson')}
			</span>
			<span class="contact-full-name">{$contactData.fullName}</span>
			{#if (contactMobileLength > 0 && isValidPhoneNumber($contactData.mobile)) || (contactPhoneLength > 0 && isValidPhoneNumber($contactData.phone))}
				{#if contactMobileLength > 0 && isValidPhoneNumber($contactData.mobile)}
					<div>
						<span>Mobil:</span>
						<a class="contact-mobile" href="tel:{$contactData.mobile}">{$contactData.mobile}</a>
					</div>
				{/if}
				{#if contactPhoneLength > 0 && isValidPhoneNumber($contactData.phone)}
					<div>
						<span>Telefon:</span>
						<a class="contact-phone" href="tel:{$contactData.phone}">{$contactData.phone}</a>
					</div>
				{/if}
			{:else if !$isSaasInternalLot}
				<div>
					<span>Telefon:</span>
					<a class="contact-phone" href="tel:{$t('UI.MineralMinds.phoneNr')}"
						>{$t('UI.MineralMinds.phoneNr')}</a
					>
				</div>
			{/if}
			{#if contactMailLength > 0}
				<div>
					<span>E-Mail:</span>
					{#if showTooltip}
						<div>
							<Tooltip msg={$contactData.eMail}>
								<div class="contact-mail-wrapper">
									<a class="contact-mail" href="mailto:{$contactData.eMail}">{$contactData.eMail}</a
									>
								</div>
							</Tooltip>
						</div>
					{:else}
						<a class="contact-mail" href="mailto:{$contactData.eMail}">{$contactData.eMail}</a>
					{/if}
				</div>
			{/if}
		</div>
	</div>
{:else if !$isSaasInternalLot}
	<div class="contact-box-optimizer">
		<div class="contact-box-contact contact-box-mm-contact">
			<span class="contact-box-headline">{$t('UI.MineralMinds.thereForYou')}</span>
			<div>
				<span>Telefon: </span>
				<a id="contact-box-default-phone" href="tel:{$t('UI.MineralMinds.phoneNr')}"
					>{$t('UI.MineralMinds.phoneNr')}</a
				>
			</div>
		</div>
	</div>
{/if}

<style lang="scss">
	@import '$styles/global';

	.contact-box-default-phone-icon {
		width: 12px;
		height: 12px;
		background-size: contain;
		background: url('@/icons/icon_phone.svg') no-repeat;
		margin-top: 1px;
	}

	span {
		height: 11px;

		@include roboto-font(11px, 500, 0.75rem, black);

		text-align: left;
	}

	.contact-box-optimizer {
		width: 16.125rem;
		height: 5.5rem;
		background-color: white;
		border-radius: 0.25rem;
		border: 2px solid $primaryColor;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		padding-left: 1rem;
	}

	.contact-box-contact {
		display: flex;
		flex-direction: column;
		row-gap: 0.16rem;
		max-width: 15rem;

		& > span.contact-box-headline {
			@include roboto-font(0.875rem, 700, 0.6875rem, $primaryColor);

			text-transform: uppercase;
		}

		& > span {
			@include roboto-font(0.875rem, 400, 0.625rem, black);
		}

		& > div {
			display: flex;
			flex-direction: row;

			& > span {
				@include roboto-font(0.875rem, 400, 0.625rem, black);

				padding-right: 0.2rem;
				align-self: baseline;
			}

			& a {
				@include roboto-font(0.875rem, 400, 0.625rem, $primaryColor);

				align-self: baseline;
			}

			& a.contact-mail {
				@include roboto-font(0.875rem, 400, 0.625rem, $primaryColor);

				align-self: center;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
				max-width: 12rem;
				height: 11px;
			}
		}
	}

	.contact-mail-wrapper {
		text-overflow: ellipsis;
		display: flex;
		height: 11px;
	}

	.contact-box-mm-contact {
		row-gap: 0.5rem;
	}
</style>
